import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page9() {
  useEffect(() => {
    document.title = "Маяк — Страница 14"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page13" />
        <ForwardLink href="/page15" />
      </div>

      <p style={{ textAlign: "right" }}>14.</p>
      <p>
        Он вырывает несколько гнилых черепиц. Доски под крышей<br/>
        тоже гниют. <i>Да, вот эта дыра.</i>
      </p>
      <p>Он наклоняется...</p>
      <p>ВИДИТ ЧЕРЕЗ ДЫРУ В КРЫШЕ:</p>
      <p>СТАРИК спит. Но он двигается.</p>
      <p>МОЛОДОЙ наклоняется ближе...</p>
      <p>
        СТАРИК нежно ТРАХАЕТ свой потный матрас, просто нежно<br/>
        толкая бедра. Это едва заметно. Рефлексивное движение.
      </p>
      <p>МОЛОДОЙ смотрит.</p>
      <p>Задержка.</p>
      <br/>
      <p>СНАРУЖИ. САРАЙ – ДЕНЬ</p>
      <p>МОЛОДОЙ открывает деревянную дверь, которая почти падает с петель:</p>
      <p>
        Сарай завален. Бочки с сушеной рыбой, полки для инструментов,<br/>
        кастрюли, упакованные в бумагу посылки, деревянные ящики, бочки, бочонки,<br/>
        веревка...
      </p>
      <br/>
      <p>СНАРУЖИ. САРАЙ ДЛЯ УГЛЯ – ДЕНЬ</p>
      <p>МОЛОДОЙ открывает дверь: <u>УГОЛЬ</u>. Целая куча.</p>
      <p>Дверь падает с петель.</p>
      <br/>
      <p>СНАРУЖИ. САРАЙ ДЛЯ УГЛЯ – ПОЗЖЕ</p>
      <p>Он загружает тачку, переполненную углем.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ТРОПИНКА – НЕПРЕРЫВНО</p>
      <p>
        Он толкает тачку вниз по скале. (Само собой,<br/>
        колеса скрипят.)
      </p>
      <p>
        Он продолжает толкать. Один неверный шаг может привести к тому,<br/>
        что вся куча свалится с тачки вниз по острову...
      </p>
      <br/>
      <p>СНАРУЖИ. ЗДАНИЕ ФОГОРНА – НЕПРЕРЫВНО</p>
      <p>Он толкает тачку к двери...</p>
      <p>ЧАЙКА стоит перед старой дверью, охраняя ее.</p>
      <p style={{ textAlign: "right" }}>14.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page13" />
        <ForwardLink href="/page15" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708105858/the-lighthouse-script/u38mj4k43nsjpozjbd2e.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page9;
